import React from "react"
import Select, { Props } from "react-select"
import { SelectOption } from "@interfaces/ui"
import { CSSObject } from "@emotion/serialize"

export interface ManualSelectProps extends Props {
  error?: string
  defaultOption?: SelectOption
  controlStyle?: CSSObject
}

export const ManualSelect: React.FC<ManualSelectProps> = ({
  className,
  controlStyle,
  ...props
}) => {
  return (
    <Select
      {...props}
      className={className}
      styles={{
        control: (props) => ({
          ...props,
          border: "1px solid #ececec",
          borderColor: "#ececec",
          boxShadow: "0 0 0 #ececec",
          borderRadius: "5px",
          minHeight: 0,
          padding: "10px 18px",
          "&:hover": {
            border: "1px solid #ececec",
            boxShadow: "0 0 0 #ececec",
          },
          "&:focus": {
            border: "1px solid #ececec",
            boxShadow: "0 0 0 #ececec",
          },
          "@media(max-width: 576px)": {
            fontSize: "12px",
          },
          ...controlStyle,
        }),
        input: (props) => ({
          ...props,
          margin: 0,
          paddingTop: 0,
          paddingBottom: 0,
        }),
        placeholder: (props) => ({
          ...props,
          color: "#979797",
          marginLeft: 0,
          marginRight: 0,
        }),
        dropdownIndicator: (props) => ({
          ...props,
          padding: 0,
        }),
        valueContainer: (props) => ({
          ...props,
          padding: "0 5px 0 0",
        }),
        option: (props, { isSelected }) => ({
          ...props,
          backgroundColor: isSelected ? "#0DAD8E" : "white",
          "&:active": {
            backgroundColor: "rgba(13, 173, 142, 0.5)",
          },
          "@media(max-width: 576px)": {
            fontSize: "12px",
          },
        }),
      }}
    />
  )
}
